import React from 'react'
import { MdOutlineWhatsapp } from 'react-icons/md'
import Banner from './banner'
import Shake from './shake'
import SkillSystem from './skill-system'
import StudentExists from './student-exists'
import Gap from './gap'
import Reality from './reality'
import Model from './model'
import WhatBuilds from '../SurgeStudents/what-builds'
import FishingStory from '../SurgeStudents/fishing-story'
import ViralArticle from '../SurgeStudents/viral-article'
import Speaciality from './speacialist'
import Workflow from './workflow'
import Philosophy from '../SurgeStudents/philosophy'
import Powered from './powered'
import Certified from './ceritified'
import Colleges from './colleges'
import Faq from '../SurgeStudents/faq'
import Header from '../../header'
import Slot from './slot'

export default function PaduSpoke() {
    return (
        <div className='relative overflow-hidden w-full'>
            <Header />
            <Banner />
            <Shake />
            <SkillSystem />
            <StudentExists />
            <Gap />
            <Reality />
            <Model />
            <WhatBuilds />
            <Slot />
            <FishingStory />
            <ViralArticle />
            <Speaciality />
            <Workflow />
            <Philosophy />
            <Powered />
            <Certified />
            <Colleges />
            <div className='w-full bg-[#34C759] mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] md:p-[40px] relative z-0 overflow-hidden text-center'>
                <p className='text-[#FFFFFF] font-semibold text-[24px] md:text-[32px] lg:text-[48px]'>India doesn’t lack talent.</p>
                <p className='text-[#FFFFFF] font-semibold text-[24px] md:text-[32px] lg:text-[48px]'>Students only need clarity, confidence & capability.</p>
                <p className='mt-[20px] md:mt-[40px] font-normal text-[#DBEAFE] text-[14px] md:text-[20px] lg:text-[28px]'>Together with colleges, we can shape a future-ready generation.</p>
                <button className='w-full md:w-[346px] h-[40px] md:h-[64px] mt-[20px] md:mt-[40px]  rounded-[12px] bg-[#FFFF] text-[#34C759] text-[16px] md:text-[24px] font-semibold'
                    onClick={() => {
                        const slotDiv = document.getElementById("slot");
                        if (slotDiv) {
                            slotDiv.scrollIntoView({ behavior: "smooth", block: "start" });
                        }
                    }}
                >Partner With Surge
                </button>
            </div>
            <Faq />
            <div className='border-t border-[#1E2939] text-[12px] md:text-[14px] text-[#99A1AF] font-normal p-[20px] md:px-[42px] text-center flex flex-row-reverse lg:flex-row justify-end lg:justify-between flex-wrap gap-[30px] lg:items-center mx-auto bg-[#000]'>
                <p>© 2025 Surge Students. All rights reserved.</p>
                <div className='w-full md:w-auto'>
                    <p className='font-bold text-[16px] md:text-[20px] text-red-600 text-start'>Connect with us</p>
                    <div className='flex items-center gap-[10px] font-semibold text-[14px] md:text-[18px] mt-[10px]'>
                        <MdOutlineWhatsapp className='text-[#27AE60] flex-shrink-0' />
                        <p >+91 90430 66871 (Whatsapp only)</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
